export default "__VITE_ASSET__aff25183__"